import React, { useEffect, useState } from 'react';

import NavbarLarge from './NavbarLarge';
import NavbarSmall from './NavbarSmall';

const Navbar = ({ setAccessibilityOpen }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Switch to small navbar on tablets & mobile
  const isSmall = screenWidth < 1200; // <-- change breakpoint here

  return isSmall ? <NavbarSmall setAccessibilityOpen={setAccessibilityOpen} /> 
                 : <NavbarLarge setAccessibilityOpen={setAccessibilityOpen} />;
};

export default Navbar;
